// src/services/NumbersService.js
import axios from 'axios'

const NumbersService = {
  async list(params = {}) {
    return axios.get('numbers', { params })
  },

  async get(id, params = {}) {
    return axios.get(`numbers/${encodeURIComponent(id)}`, { params })
  },

  async create(payload = {}) {
    return axios.post('numbers', payload)
  },

  async update(id, payload = {}) {
    return axios.put(`numbers/${encodeURIComponent(id)}`, payload)
  },

  async patch(id, payload = {}) {
    return axios.patch(`numbers/${encodeURIComponent(id)}`, payload)
  },

  async destroy(id) {
    return axios.delete(`numbers/${encodeURIComponent(id)}`)
  }
}

export default NumbersService
